import {hasSomeLayoutRuleConfig, RuleKey} from "@buildwithflux/models";

import {createActionRecordAction} from "@buildwithflux/core";

export const removeNodeRules = createActionRecordAction(
    "removeNodeRules",
    (nodeId: string, ruleKeys: RuleKey[]) => {
        const hasInheritedRules = hasSomeLayoutRuleConfig(ruleKeys, "allChildNodesWillInheritThisRule");
        const hasInheritedCalculations = hasSomeLayoutRuleConfig(ruleKeys, "affectsDescendantCalculations");
        const requiresDescendantRebake = hasSomeLayoutRuleConfig(ruleKeys, "requiresDescendantRebake");
        const requiresNetDescendantRebake = hasSomeLayoutRuleConfig(ruleKeys, "requiresNetDescendantRebake");

        return {
            payload: {
                nodeId,
                ruleKeys,
                canUndo: true,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,

                hasInheritedRules,
                hasInheritedCalculations,
                requiresDescendantRebake,
                requiresNetDescendantRebake,
            },
        };
    },
    "remove object-specific pcb layout rules",
);
